import {
  VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_VALUE_ALL_PASSENGER_CARS,
  VEHICLE_VALUE_ELECTRIC_CARS,
  VEHICLE_VALUE_HATCHBACK,
  VEHICLE_VALUE_HYBRID_CARS,
  VEHICLE_VALUE_LUXURY_SEDAN,
  VEHICLE_VALUE_MID_SIZED_SEDAN,
  VEHICLE_VALUE_MPV,
  VEHICLE_VALUE_SPORTS_CARS,
  VEHICLE_VALUE_STATIONWAGON,
  VEHICLE_VALUE_SUV,
} from '@/constants/global';

export const isVehicleType = (str: unknown): boolean => (!!((
  typeof str === 'string' && (str === VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES
  || str === VEHICLE_VALUE_ALL_PASSENGER_CARS
  || str === VEHICLE_VALUE_MID_SIZED_SEDAN
  || str === VEHICLE_VALUE_LUXURY_SEDAN
  || str === VEHICLE_VALUE_HATCHBACK
  || str === VEHICLE_VALUE_MPV
  || str === VEHICLE_VALUE_SUV
  || str === VEHICLE_VALUE_SPORTS_CARS
  || str === VEHICLE_VALUE_STATIONWAGON
  || str === VEHICLE_VALUE_HYBRID_CARS
  || str === VEHICLE_VALUE_ELECTRIC_CARS))));
